<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default { name: 'App' };
</script>

<style>
html, body {
  margin: 0; padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  background: #f5f7fa;
}
#app {
  max-width: 480px;
  margin: 0 auto;
  min-height: 100vh;
}
</style>
